import { fetch } from '../fetchWrapper/fetch';
import { EXTENSIONS_API_URL } from '../../constants';
import { ErrorMessages } from '../constants';
import { IExtension, IExtensionsResponse } from './types';

export const getExtensions = async (brandId: string): Promise<IExtension[]> => {
  try {
    const res = await fetch(EXTENSIONS_API_URL, {
      headers: {
        'brand-id': brandId,
      },
    });
    if (res.status !== 200) {
      const error: { message: string } = await res.json();
      throw new Error(error.message);
    }
    const json: IExtensionsResponse = await res.json();
    return json.data;
  } catch (e) {
    throw new Error(e?.message || ErrorMessages.SORRY_SOMETHING_WENT_WRONG);
  }
};
